export enum DateFormats {
  DateFormatWithTime,
  DateFormatWithoutTime,
}

export const DATE_FORMATS_MAP = new Map<DateFormats, Object>([
  [
    DateFormats.DateFormatWithTime,
    { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' },
  ],
  [DateFormats.DateFormatWithoutTime, { year: 'numeric', month: 'short', day: 'numeric' }],
]);
